import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            精选视频
          </h2>
          <div className="mt-4 w-16 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">高清视频合集，热门内容一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-500 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.views} 次观看</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <span className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap">
            <i className="ri-play-list-2-line"></i>
            查看更多视频合集
          </span>
        </div>
      </div>
    </section>
  );
}